import React from 'react';
import {useTranslation} from "react-i18next";
import CustomButton from "../../components/UI/customButton/customButton";
import {Link, redirect, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {SuccessIcon} from "../../icons/icons";

export const SuccessPay = () => {

  const {t} = useTranslation()

  const [param] = useSearchParams()

  if(param?.get('visaId'))
  return (
    <div className={`my-container  h-auto`}>
      <div className={" relative bg-white rounded-lg  flex flex-col items-center gap-5 md:gap-9 w-full !mt-20 py-5 md:py-10 px-4 md:px-[13%] mb-8"}>
        <SuccessIcon/>
        <span className={"text-lg md:text-2xl text-primary-400 font-medium"}>{t("successfulPayment")}</span>
        <span className={"md:w-1/2 2xl:w-full text-sm md:text-base text-center leading-8 text-gray-500 font-light md:font-semibold"}>{t("trackingNumber") + " : " + param?.get('visaId')}</span>
        <span className={"md:w-1/2 2xl:w-full text-sm md:text-base text-center leading-8 text-gray-500 font-light md:font-light"}>{t("successfulPaymentDes")}</span>
        <Link to={'/dashboard'} className={"w-[330px]"}>
          <CustomButton  title={ "understand"} onClick={undefined} styles={undefined}/>
        </Link>
      </div>
      </div>
  );

  return redirect('/dashboard')
};

